/* biome-ignore-all lint/suspicious/noExplicitAny: form handling */
import { Button, Card, Col, Form, Input, Row, Select, Space } from "antd"
import { SearchOutlined, ReloadOutlined } from "@ant-design/icons"
import type React from "react"
import type { SetSearchLogQueryParams } from "@/services/log/setSearchLogApi"

interface SetSearchLogFilterFormProps {
  onSearch: (values: SetSearchLogQueryParams) => void
  loading?: boolean
  initialValues?: SetSearchLogQueryParams
}

const ACTION_OPTIONS = [
  { label: "Tất cả hành động", value: "" },
  { label: "Click (Chọn bộ từ)", value: "click" },
  { label: "Blur (Rời khỏi ô tìm)", value: "blur" },
  { label: "Enter (Nhấn Enter)", value: "enter" },
]

const HAS_RESULTS_OPTIONS = [
  { label: "Tất cả kết quả", value: "" },
  { label: "Có kết quả khớp (> 0)", value: "yes" },
  { label: "Không có kết quả (= 0)", value: "no" },
]

export const SetSearchLogFilterForm: React.FC<SetSearchLogFilterFormProps> = ({
  onSearch,
  loading = false,
  initialValues,
}) => {
  const [form] = Form.useForm()

  const handleFinish = (values: any) => {
    onSearch({
      user_search: values.user_search?.trim() || undefined,
      action: values.action || undefined,
      has_results: values.has_results || undefined,
    })
  }

  const handleReset = () => {
    form.resetFields()
    onSearch({})
  }

  return (
    <Card className="mb-2 shadow-xs">
      <Form
        form={form}
        layout="vertical"
        onFinish={handleFinish}
        initialValues={{
          user_search: initialValues?.user_search,
          action: initialValues?.action ?? "",
          has_results: initialValues?.has_results ?? "",
        }}
      >
        <Row gutter={[16, 8]}>
          {/* 1. Tìm kiếm người dùng (Đưa lên đầu) */}
          <Col xs={24} sm={12} md={8} lg={8}>
            <Form.Item label="Người dùng (Tên, Email, #ID)" name="user_search">
              <Input placeholder="Nhập tên, email hoặc #ID..." allowClear />
            </Form.Item>
          </Col>

          {/* 2. Hành động (action) */}
          <Col xs={24} sm={12} md={8} lg={8}>
            <Form.Item label="Loại tương tác (action)" name="action">
              <Select options={ACTION_OPTIONS} />
            </Form.Item>
          </Col>

          {/* 3. Kết quả khớp */}
          <Col xs={24} sm={12} md={8} lg={8}>
            <Form.Item label="Kết quả khớp" name="has_results">
              <Select options={HAS_RESULTS_OPTIONS} />
            </Form.Item>
          </Col>

          {/* Actions */}
          <Col xs={24} className="flex justify-end">
            <Space>
              <Button icon={<ReloadOutlined />} onClick={handleReset}>
                Đặt lại
              </Button>
              <Button type="primary" htmlType="submit" icon={<SearchOutlined />} loading={loading}>
                Tìm kiếm
              </Button>
            </Space>
          </Col>
        </Row>
      </Form>
    </Card>
  )
}

export default SetSearchLogFilterForm
